import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <p className="footer__copy">© Yambotsu {new Date().getFullYear()}. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
